import { render, staticRenderFns } from "./ClassifiedNotice.vue?vue&type=template&id=df2c8dc0"
import script from "./ClassifiedNotice.vue?vue&type=script&lang=js"
export * from "./ClassifiedNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports